import { useMemo, useState } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import PermissionList, { RoleSubmitPayload } from './PermissionList';
import { RolePermission, useRoleDetail, useUpdateRole } from '../Roles.hooks';
import Spin from 'Components/Spin/Spin';
import { getAppRoutes } from 'Pages/App/App.constants';
import { Notification } from 'Components';
import { useTranslation } from 'react-i18next';
import { useDashboardContext } from 'Pages/Dashboard/DashboardContext';

function ViewRole() {
	const { roleId } = useParams<{ roleId: string }>();
	const history = useHistory();
	const [mode, setMode] = useState<'view' | 'edit'>('view');
	const { t } = useTranslation();
	const { setToastInfo } = useDashboardContext();
	const { role, permissionList, loading } = useRoleDetail(roleId);
	const [updateRole, { loading: updating }] = useUpdateRole();
	const initialValues = useMemo(() => {
		if (!role) {
			return undefined;
		}
		return {
			roleId: role.id,
			roleName: role.role,
			sourceRoleName: role.role,
			description: role.description,
			isPrimary: role.isPrimary,
			permissions: role.permissions?.map((permission: RolePermission) => permission.id) ?? [],
		};
	}, [role]);

	const handleSubmit = async (values: RoleSubmitPayload) => {
		try {
			await updateRole(role, values);
			setToastInfo?.({
				message: t('notification.update.success', { name: 'Role' }),
				type: 'success',
				icon: 'check'
			});
			history.push(getAppRoutes().ROLES);
		} catch (error) {
			Notification.error({
				description: t('errorCodes.genericErrorMessage')
			});
		}
	};

	if (loading || !role || !initialValues) return <Spin />

	return (
		<PermissionList
			mode={mode}
			setMode={setMode}
			loading={updating}
			permissionList={permissionList}
			initialValues={initialValues}
			onCancel={() => history.goBack()}
			onSubmit={handleSubmit}
		/>
	);
}

export default ViewRole;
